// extracted by mini-css-extract-plugin
module.exports = {"widget":"widget_widget__3jhf6","progress":"widget_progress__xZasZ","content":"widget_content__yeSUn"};